import { forwardRef } from "react";

const Input = forwardRef(
  (
    { label, error, type = "text", className = "", required = false, ...props },
    ref,
  ) => {
    const inputClasses = `
    block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm 
    placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500
    ${error ? "border-red-300 focus:ring-red-500 focus:border-red-500" : ""}
    ${className}
  `;

    return (
      <div className="space-y-1">
        {label && (
          <label className="block text-sm font-medium text-gray-700">
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </label>
        )}
        <input ref={ref} type={type} className={inputClasses} {...props} />
        {error && <p className="text-sm text-red-600">{error}</p>}
      </div>
    );
  },
);

Input.displayName = "Input";

const PasswordInput = forwardRef(({ ...props }, ref) => {
  return <Input ref={ref} type="password" {...props} />;
});

PasswordInput.displayName = "PasswordInput";

export { Input, PasswordInput };
export default Input;
